import { render, staticRenderFns } from "./associateAssets.vue?vue&type=template&id=10fe2704&scoped=true&"
import script from "./associateAssets.vue?vue&type=script&lang=js&"
export * from "./associateAssets.vue?vue&type=script&lang=js&"
import style0 from "./associateAssets.vue?vue&type=style&index=0&id=10fe2704&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fe2704",
  null
  
)

export default component.exports